const formatWithDelimiters = (number: number, precision: number, thousands?: string, decimal?: string) => {
  if (isNaN(number) || number == null) {
    return "0"
  }

  const numberStr = (number / 100.0).toFixed(precision)

  const parts = numberStr.split(".")
  const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + (thousands || ","))
  const cents = parts[1] ? ((decimal || ".") + parts[1]) : ""

  return dollars + cents
}

export const formatMoney = (cents: number) => {
  let value = ""
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/
  const formatString = "${{amount}}"

  switch (formatString.match(placeholderRegex)?.[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2)
      break
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0)
      break
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",")
      break
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",")
      break
  }

  return formatString.replace(placeholderRegex, value)
}
